const PREFER_NOT_TO_SAY_VALUE = "notToSay";

export const includePreferNotSayOption = options => {
  return [
    ...options,
    {
      label: "Prefer not to say",
      value: PREFER_NOT_TO_SAY_VALUE
    }
  ];
};

export const getFormattedValue = value => {
  return value === PREFER_NOT_TO_SAY_VALUE ? null : value;
};
